import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import env from '@travel/env';
import Layout from '@travel/traveler-core/components/Layout';
import { useTranslation } from '@travel/traveler-core/hooks';
import useMemberKeepAlive from '@travel/traveler-core/hooks/useMemberKeepAlive';

import useHeaderEvents from 'promotions/hooks/useHeaderEvents';
import ErrorPage from 'promotions/pages/ErrorPage';
import { refreshAuthCode } from 'promotions/store/authCode/actions';
import { getIsLoggedIn } from 'promotions/store/authCode/selectors';
import { getIsAPIError } from 'promotions/store/commonError/selectors';

import SEO from './components/SEO';

import styles from '../style/app.module.scss';

import { SITE_IMAGE_URL } from 'promotions/constants/common';
import { pushLocation } from 'promotions/store/__router/actions';

const App = (props: any) => {
  const dispatch = useDispatch();

  const isAPIError = useSelector(getIsAPIError);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const normalPageTitle = useTranslation({ id: 'Booking_List.Header.HTML_Title' });
  // refresh token
  const refreshTokenHookCallback = useCallback(() => {
    dispatch(refreshAuthCode());
  }, [dispatch]);

  useHeaderEvents();
  useMemberKeepAlive(isLoggedIn, refreshTokenHookCallback);

  const envName = env('UNIVERSAL_ENV_NAME');

  let content = props.children;
  if (isAPIError) content = <ErrorPage />;

  return (
    <div id="app" data-testid="app-wrapper" className={styles.appWrapper}>
      <SEO title={normalPageTitle} imageUrl={SITE_IMAGE_URL} />
      {envName && (
        <button
          data-testid="app-env-button"
          className={styles.envButton}
          tabIndex={-1}
          onClick={() => {
            dispatch(
              pushLocation(
                window.location.pathname.replace(env('UNIVERSAL_BASE_NAME') as string, '') +
                  window.location.search,
              ),
            );
          }}
        >
          {envName}
        </button>
      )}
      <Layout className={styles.layout}>{content}</Layout>
      {}
      <div dangerouslySetInnerHTML={{ __html: '<global-footer />' }} />
    </div>
  );
};

export default App;
